"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./common/models");
var constants_1 = require("./common/constants");
var encrypt_1 = require("./common/encrypt");
var data_from_url_1 = require("./data-from-url");
var ClientConfig = /** @class */ (function () {
    function ClientConfig() {
    }
    return ClientConfig;
}());
var SetOptions = /** @class */ (function () {
    function SetOptions() {
        this.disableNewRedirect = false;
    }
    return SetOptions;
}());
var DeleteOptions = /** @class */ (function () {
    function DeleteOptions() {
        this.needToLogin = false;
    }
    return DeleteOptions;
}());
var Client = /** @class */ (function () {
    function Client(config) {
        this.config = config;
        this.validateConfig();
    }
    Object.defineProperty(Client.prototype, "responseFromUrl", {
        get: function () {
            return data_from_url_1.getDataFromUrl();
        },
        enumerable: true,
        configurable: true
    });
    Client.prototype.set = function (value, options) {
        if (options === void 0) { options = new SetOptions(); }
        this.redirect(new models_1.Request({
            action: constants_1.ACTIONS.SET,
            payload: { key: this.config.key, value: value },
            disableNewRedirect: options.disableNewRedirect
        }));
    };
    Client.prototype.get = function () {
        this.redirect(new models_1.Request({
            action: constants_1.ACTIONS.GET,
            payload: { key: this.config.key }
        }));
    };
    Client.prototype.delete = function (options) {
        if (options === void 0) { options = new DeleteOptions(); }
        this.redirect(new models_1.Request({
            action: constants_1.ACTIONS.DELETE,
            payload: { key: this.config.key },
            needToLogin: options.needToLogin
        }));
    };
    Client.prototype.redirect = function (requestData) {
        requestData.origin = window.location.origin;
        requestData.returnTo = window.location.href;
        window.location.href = this.config.hubUrl + "?cdc=" + encrypt_1.encode(requestData);
    };
    Client.prototype.validateConfig = function () {
        if (!this.config.hubUrl || !this.config.key) {
            throw new models_1.InvalidConfigError('Properties "hubUrl" and "key" are required');
        }
    };
    return Client;
}());
exports.Client = Client;
